export default __webpack_public_path__ + "859d7ff3374911f271c172b2d4fbb538.png";